import { merge } from "lodash";

const hasStorage = (() => {
  try {
    const mod = "testStorage";
    localStorage.setItem(mod, mod);
    localStorage.removeItem(mod);
    return true;
  } catch (exception) {
    return false;
  }
})();

export function loadState(key, mergeObj = null, init = {}) {
  // console.log("loading: " + key);
  if (hasStorage) {
    try {
      let tmp = JSON.parse(localStorage.getItem(key));
      if (tmp && typeof tmp === "object") {
        if (mergeObj) {
          tmp = merge(tmp, mergeObj);
        }
        return tmp;
      }
      return init;
    } catch (exception) {
      return init;
    }
  } else {
    return init;
  }
}

export function loadValue(key, param) {
  // console.log("loading: " + key);
  if (hasStorage) {
    try {
      const tmp = JSON.parse(localStorage.getItem(key));
      if (tmp && typeof tmp === "object") {
        return tmp[param];
      }
      return null;
    } catch (exception) {
      return null;
    }
  } else {
    return null;
  }
}

export function saveValue(key, param, value) {
  // console.log("loading: " + key);
  if (hasStorage) {
    try {
      const tmp = JSON.parse(localStorage.getItem(key));
      if (tmp && typeof tmp === "object") {
        tmp[param] = value;
        localStorage.setItem(key, JSON.stringify(tmp));
      }
      return null;
    } catch (exception) {
      return null;
    }
  } else {
    return null;
  }
}

export function saveState(key, value) {
  if (hasStorage) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (exception) {
      return false;
    }
  }
  return true;
}

export function clearState(key) {
  if (hasStorage) {
    try {
      localStorage.removeItem(key);
    } catch (exception) {
      return false;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/poolTools.js